import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Hero.css";
import Video2 from "../../assets/video2.mp4";
import Video3 from "../../assets/video3.mp4";
import HeroImage from "../../assets/hero-image.png";

const Hero = () => {
  const slides = [
    { id: 0, type: "image", src: HeroImage, title: "NAVI MUMBAI", subtitle: "The City of Future" },
    { id: 1, type: "video", src: Video2, title: "Mumbai 3.0", subtitle: "KSC Town" },
    { id: 2, type: "video", src: Video3, title: "Aerocity Developers", subtitle: "Luxury Living" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (slides[currentSlide].type === "image") {
      const timer = setTimeout(handleNextSlide, 5000);
      return () => clearTimeout(timer);
    }
  }, [currentSlide]);

  return (
    <div className="hero-container">
      <div className="hero-main-viewport">
        {/* Background Slider */}
        <AnimatePresence mode="wait">
          <motion.div 
            key={currentSlide}
            className="hero-slide"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            {slides[currentSlide].type === "video" ? (
              <video
                src={slides[currentSlide].src}
                className="hero-bg-media"
                autoPlay
                muted
                playsInline
                onEnded={handleNextSlide}
              />
            ) : (
              <img
                src={slides[currentSlide].src}
                className="hero-bg-media"
                alt="Hero"
              />
            )}
            <div className={`hero-overlay ${slides[currentSlide].type === "image" ? "image-overlay" : ""}`}></div>
          </motion.div>
        </AnimatePresence>

        {/* Content Overlay */}
        <div className="hero-content">
          <AnimatePresence mode="wait">
            <motion.div
              key={`text-${currentSlide}`}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -30, opacity: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <h1>{slides[currentSlide].title}</h1>
              {slides[currentSlide].subtitle && <p>{slides[currentSlide].subtitle}</p>}
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Navigation Dots */}
        <div className="hero-dots">
          {slides.map((_, index) => (
            <span 
              key={index} 
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;